import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import Helpers from "../Helper/Helpers";

// const offers = [
//   { image: "./CABINET BANNER.png" },
//   { image: "./SPEAKER BANNER.png" },
//   { image: "./KEYBOARD BANNER.png" },
//   { image: "./MONITOR BANNER.png" },
// ];

const Banner = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [banners, setBanners] = useState([]);
  const [offers, setBanners1] = useState([]);

  useEffect(() => {
    FetchAllBanner();
    FetchAllSmallBanner();
  }, []);

  const FetchAllBanner = async () => {
    try {
      const res = await Helpers("/admin/banner/get", "GET");
      if (res?.status) {
        const fetchedBanners = res?.data?.reverse();
        setBanners(fetchedBanners);
        if (fetchedBanners.length > 0) {
          setCurrentSlide(0);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const FetchAllSmallBanner = async () => {
    try {
      const res = await Helpers("/admin/smallbanner/get", "GET");
      if (res?.status) {
        const fetchedBanners = res?.data;
        setBanners1(fetchedBanners);
        if (fetchedBanners.length > 0) {
          // setCurrentSlide(0);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (banners.length === 0) return;

    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % banners.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [banners]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % banners.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + banners.length) % banners.length);
  };

  return (
    <>
      {/* Banner Section */}
      <div
        className="relative w-screen overflow-hidden mb-2 h-[180px] md:h-[400px]"
        style={{
          marginLeft: "calc(-50vw + 50%)",
          marginRight: "calc(-50vw + 50%)",
          marginTop: "60px",
        }}
      >
        {/* Banner Slides */}
        {banners.map((banner, index) => (
          <div
            key={index}
            className={`absolute top-0 left-0 w-full h-full transition-opacity duration-700 ease-in-out ${
              index === currentSlide ? "opacity-100 z-10" : "opacity-0 z-0"
            }`}
          >
            <img
              src={banner?.image}
              alt={`Slide ${index}`}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black bg-opacity-40" />
          </div>
        ))}

        {/* Navigation Buttons */}
        {banners.length > 1 && (
          <>
            <button
              onClick={prevSlide}
              className="absolute z-20 left-4 top-1/2 -translate-y-1/2 bg-black bg-opacity-60 p-2 rounded-full hover:bg-opacity-80 transition"
            >
              <ChevronLeft className="h-6 w-6 text-white" />
            </button>
            <button
              onClick={nextSlide}
              className="absolute z-20 right-4 top-1/2 -translate-y-1/2 bg-black bg-opacity-60 p-2 rounded-full hover:bg-opacity-80 transition"
            >
              <ChevronRight className="h-6 w-6 text-white" />
            </button>
          </>
        )}
      </div>

      {/* Offer Section */}
      <div className="w-full px-4 md:px-0 my-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {offers.map((item, index) => (
            <div
              key={index}
              className="w-full h-auto overflow-hidden shadow-md"
            >
              <img
                src={item?.image}
                alt={`offer-${index}`}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Banner;
